module.exports = __webpack_public_path__ + "img/035-quick.87fe6d21.svg";